var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconPerson = function SvgIconPerson(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5c1.934 0 3.5 1.566 3.5 3.5S13.934 12 12 12a3.5 3.5 0 0 1-3.5-3.5C8.5 6.566 10.066 5 12 5m0 8.75c3.867 0 7 1.566 7 3.5V19H5v-1.75c0-1.934 3.133-3.5 7-3.5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconPerson);
export { ForwardRef as ReactComponent };